import { combineReducers } from "redux";
import customerService from "./CustomerService";


export default combineReducers({
  customerService,
});
